import "bootstrap";
import "./fading-animation";
import { headerInverted, headerPadding, scrollDownUp } from "./header";
import "./timeline";
import Swiper from './swiper-bundle.min.js';

// swiper splash
const swiperSplash = () => {
	return document.querySelector(".swiper-splash") ? new Swiper(".swiper-splash", {
		effect: "fade",
		loop: true,
		autoplay: {
			delay: 5000,
		},	
		navigation: {
			nextEl: ".swiper-splash-next",
			prevEl: ".swiper-splash-prev",
		},
	}) : false;
}

window.addEventListener("DOMContentLoaded", (event) => {
/*   headerPadding(); */
  headerInverted();
  swiperSplash();
});

window.addEventListener("resize", (event) => {
 /*  headerPadding(); */
});

window.addEventListener("scroll", (event) => {
  /* scrollDownUp(); */
  headerInverted();
});


